<template>
  <AttrGroup title="动画过程" :show-add="true" :card="false" @add="onAdd">
    <div class="gap-1 flex flex-col">
      <IFTTTAnimationItem
        v-for="animation in animations"
        :key="animation.id"
        :ifttt="ifttt"
        :animation="animation"
        class="bg-black-card"
        @delete="() => onDel(animation.id)"
        @update="(id:string,data:any) => iftttStore.updateAnimation(ifttt.id,id, data)"
      />
    </div>
  </AttrGroup>
</template>

<script setup lang="ts">
import { useIfttt } from '@/hooks/use-ifttt';
import { useIFTTTStore } from '@/store/use-ifttt-store';
import { Modal } from 'ant-design-vue';
import { computed, PropType } from 'vue';

const props = defineProps({
  ifttt: {
    type: Object as PropType<IFTTT>,
    required: true
  }
});
const iftttStore = useIFTTTStore();
const { animationTypeOptions } = useIfttt();
const onAdd = () => {
  if (props.ifttt.animations.length >= 5) {
    Modal.warning({
      title: '不可添加',
      content: '最大可添加5个动画，无法继续添加',
      okText: '知道了'
    });
    return;
  }
  // 查找剩下未添加且可用的动画
  const types = animationTypeOptions.filter(
    (item) =>
      !props.ifttt.animations.some(
        (animation) => animation.type === item.value
      ) && !item.disabled
  );
  if (!types.length) {
    Modal.warning({
      title: '不可添加',
      content: '没有更多可用的动画，无法继续添加',
      okText: '知道了'
    });
    return;
  }
  iftttStore.addAnimation(props.ifttt.id, types[0]?.value);
};
const onDel = (aniId: string) => {
  if (props.ifttt.animations.length <= 1) {
    Modal.warning({
      title: '无法删除',
      content: '至少需要一个动效',
      okText: '知道了'
    });
  } else {
    iftttStore.deleteAnimation(props.ifttt.id, aniId);
  }
};
const animations = computed(() => {
  const items = [...props.ifttt.animations];
  // 对动画进行排序
  items.sort((a, b) => {
    const aIndex = animationTypeOptions.findIndex(
      (item) => item.value === a.type
    );
    const bIndex = animationTypeOptions.findIndex(
      (item) => item.value === b.type
    );
    return aIndex - bIndex;
  });
  return items;
});
</script>

<style lang="less" scoped>
:deep(.ant-collapse-header) {
  .anticon {
    color: #fff;
    position: relative;
    top: -4px;
    margin-right: 6px !important;
  }
}
</style>
